
import IconEye from '../../icons/icon-eye/index.vue';
import IconCross from '../../icons/icon-cross/index.vue';
import Tooltip from '../tooltip/index.vue';

export default {
  name: 'rzTextField',
  components: {
    IconEye,
    Tooltip,
    IconCross,
  },
  directives: {
    mask: {
      bind(el, binding) {
        const Inputmask = require('inputmask').default;
        Inputmask(binding.value).mask(el);
      }
    }
  },
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    staticLabel: {
      type: Boolean,
      default: false,
    },
    mask: {
      type: [String, Object],
      default: '',
    },
    disabled: Boolean,
    clearable: Boolean,
    value: {
      type: [String, Number],
      default: '',
    },
    isError: Boolean,
    isHint: Boolean,
    errorText: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    big: Boolean,
    required: Boolean,
    regexp: {
      type: RegExp,
      default: null,
    },
    regexpError: {
      type: String,
      default: '',
    },
    pattern: {
      type: String,
      default: '',
    },
    inputmode: {
      type: String,
      default: '',
    },
    button: {
      type: Object,
      default: () => ({}),
    },
    autocomplete: {
      type: String,
      default: 'on',
    },
    name: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    isFocused: false,
    isAutofilled: false,
    randomId: null,
    currentType: 'text',
    isRegexpError: false,
    currentValue: '',
  }),
  computed: {
    classes() {
      return {
        'text-field--focused': this.isFocused,
        'text-field--filled': this.isFilled,
        'text-field--error': this.isError,
        'text-field--disabled': this.disabled,
        'text-field--mainColor': this.mainColor,
        'text-field--big': this.big,
        'text-field--mobile': this.isMobile,
        'text-field--dynamic-label': !this.isStaticLabel,
        'text-field--static-label': this.isStaticLabel,
      };
    },
    isFilled () {
      return this.currentValue || typeof this.currentValue === 'number' || this.isAutofilled;
    },
    isStaticLabel () {
      return !!this.placeholder.length || this.staticLabel;
    },
    definitions() {
      return {
        'A': {
          validator: '[a-zA-Zа-яА-ЯёЁ\\s\\-]',
        },
        'B': {
          validator: '[0-9]',
        },
        'C': {
          validator: '[а-яА-Я\\s]',
        },
        'D': {
          validator: '[0-9.,]',
        },
        'E': {
          validator: '[a-zA-Z@0-9._-]',
        },
        'F': {
          validator: '[.,]',
          optional: true,
        },
        'G': {
          validator: '[0-9]',
          optional: true,
        },
        'H': {
          validator: '[.,0-9]',
          optional: true,
        },
        'N': {
          validator: '[^а-яА-Яa-zA-Z]',
        },
        'P': {
          validator: '[a-zA-Z]',
        },
        'R': {
          validator: '[а-яА-Яa-zA-Z]',
        },
        'T': {
          validator: '[0-9+]',
        },
        'V': {
          validator: '[a-zA-Zа-яА-Я0-9]',
          casing: 'upper',
        },
        'X': {
          validator: '[IVXivx]',
          casing: 'upper',
        },
      };
    },
  },
  watch: {
    value: {
      handler(newVal) {
        this.$set(this, 'currentValue', newVal);
      },
      immediate: true,
    },
    currentValue: {
      handler(newVal) {
        this.$emit('input', newVal);
      },
    },
    mask: {
      handler () {
        this.$emit('input', this.$refs.input.value);
      },
    }
  },
  mounted() {
    this.randomId = String(Math.random());
    this.currentType = this.type;
  },
  methods: {
    validate(evt) {
      if (!this.regexp) return true;
      this.currentValue = evt.target.value;
      if (evt.key.match(this.regexp)) {
        this.isRegexpError = true;
        return false;
      }
      if(this.value.match(this.regexp)){
        this.isRegexpError = true;
        return false;
      }
      this.isRegexpError = false;
      return true;
    },
    focusin(e) {
      this.$emit('focusin', e);
    },
    inputFocus() {
      this.isFocused = true;
    },
    inputFocusOut() {
      this.isFocused = false;
      this.$emit('focusout');
    },
    enter(e) {
      e.preventDefault();
      e.stopPropagation();
      this.$emit('enter');
    },
    eyeClickHandler(e) {
      e.preventDefault();

      if (this.currentType === 'text') {
        this.currentType = this.type;
      } else {
        this.currentType = 'text';
      }
    },
    checkAnimation(e) {
      if(e.animationName == "onAutoFillStart") {
        console.log('a');
        this.isAutofilled = true;
      } else if(e.animationName == "onAutoFillCancel") {
        this.isAutofilled = false;
      }
    },
    clean() {
      this.currentValue = null;
      this.$emit('clean');
    }
  },
};
